export default "__VITE_ASSET__DWkkJPyf__";